<template>
	<div class="invoices">
		<ViewIPF />
		<AddReview />
		<ShowReviews title="IPF Reviews" />

		<Modal
			:show="showPaymentOption"
			content_class="col-12 col-md-9 col-lg-7 col-xl-5 confirm-modal"
		>
			<template slot="content" v-if="ipf">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Update the Payment Option
							</div>
						</div>
						<div
							class="close-modal f-r"
							@click="$store.commit('showPaymentOption', false)"
						>
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="forms">
						<Form
							classBinding="row"
							:ref="IPFModel.forms.ipfPayment.name"
							:forms="IPFModel.forms.ipfPayment.forms"
							:form_data="IPFModel.forms.ipfPayment.data"
						/>

						<div
							class="btn btn-long btn-primary"
							@click="
								updatePaymentOption({
									ref: $refs[IPFModel.forms.ipfPayment.name],
								})
							"
							:disabled="loading"
						>
							Update Payment
							<div class="lds-ring" v-show="loading">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<div class="row">
			<div class="col-12 col-md-6 col-lg-7 col-xl-6">
				<div class="title-content clearfix">
					<div class="title f-l">IPF Requests</div>
				</div>
				<div class="scroll-content">
					<scrollbar>
						<IPFItem
							v-for="ipf in ipfRequests"
							:invoice="ipf"
							@click.native="viewIPF({ ipf })"
						/>
					</scrollbar>
				</div>
			</div>

			<div class="col-12 col-md-6 col-lg-5 col-xl-5 offset-xl-1">
				<Advert />
			</div>
		</div>
	</div>
</template>

<script>
import ipf from '../rsc/stores/ipf.store';
import VueScrollbar from 'vue-scrollbar-simple';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	components: {
		Advert: () => import('../templates/ads/advert'),
		AdFeatures: () => import('../templates/ads/ad-features'),
		IPFItem: () => import('../templates/others/ipf-item'),
		ViewIPF: () => import('./view-ipf'),
		AddReview: () => import('../templates/others/review'),
		ShowReviews: () => import('../templates/others/list-reviews'),
		Form: () => import('@/libs/clarks/components/form'),
		Modal: () => import('@/components/newportal/templates/others/modal'),
		scrollbar: VueScrollbar,
	},
	beforeDestroy() {
		this.$store.unregisterModule('ipf');
	},
	created() {
		utils.registerModule('ipf', ipf, this.$store);
	},
	computed: {
		...mapGetters([
			'loading',
			'ipf',
			'IPFModel',
			'ipfRequests',
			'showPaymentOption',
		]),
	},
	data() {
		return {
			utils,
		};
	},
	methods: {
		...mapActions([
			'updatePaymentOption',
			'fetchIPFRequests',
			'getSelection',
			'viewIPF',
		]),
	},
	async mounted() {
		utils.registerModule('ipf', ipf, this.$store);
		await this.fetchIPFRequests();
		await this.getSelection();
	},
};
</script>

<style lang="less">
.invoices {
	.scroll-content {
		height: calc(100vh - 230px);
	}

	.title-content {
		margin: 10px 0 25px 10px;

		.filter {
			font-weight: 600;
			cursor: pointer;

			.icon {
				font-size: 20px;
				margin: 1px 10px 0 0;
			}
		}
		.filter:hover {
			color: var(--ne-red) !important;
		}
	}
}
</style>
